<lyceo-content [background]="true" [alternate]="true">
  <lyceo-single-card-layout *transloco="let t">
    <h3 class="mb-3">{{ t('pages.person_id_error.title') }}</h3>
    <p class="mb-3">{{ t('pages.person_id_error.description') }}</p>
    <p class="mb-2">
      {{ t('pages.person_id_error.contact_before') }}
      <a href="mailto:support@homi.nu">support@homi.nu</a
      >{{ t('pages.person_id_error.contact_after') }}
    </p>
  </lyceo-single-card-layout>
</lyceo-content>
